import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const redblueReviewPageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    redblue: {
      pages: {
        review: {
          subtitle: "态势与复盘必须绑定具体演练活动后使用。",
          activitySubtitle: "演练活动 #{activityCode}",
          selectorNotice:
            "态势与复盘必须先绑定具体演练活动；当前列表用于选择要查看态势与复盘数据的活动。",
          refreshAction: "刷新",
          alertTitle:
            "态势与复盘会直接展示活动当前汇总、报告和过程时间线；缺字段时会显式暴露 contract 问题。",
          tabs: {
            scoreSummary: "成绩汇总",
            reports: "报告",
            timeline: "时间线",
          },
          cards: {
            byCamp: "按阵营汇总",
            byMember: "按成员汇总",
          },
          stats: {
            totalScore: "总分",
            taskCount: "任务总数",
            dispatchedTaskCount: "已下发任务",
            completedTaskCount: "已完成任务",
            pendingScoreTaskCount: "待计分任务",
            noticeCount: "公告数",
            timelineEventCount: "时间线事件数",
            reportCount: "报告数",
          },
          contract: {
            situation: "态势数据",
            summary: "复盘汇总",
            scoreSummary: "成绩汇总",
            reports: "报告列表",
            timeline: "时间线",
            byCamp: "按阵营汇总",
            byMember: "按成员汇总",
          },
        },
      },
    },
  },
  en: {
    redblue: {
      pages: {
        review: {
          subtitle: "Review workspace requires a bound activity context.",
          activitySubtitle: "Activity #{activityCode}",
          selectorNotice:
            "Review workspace must bind to an activity first. Use this list to choose the activity whose situation and review data you want to inspect.",
          refreshAction: "Refresh",
          alertTitle:
            "Review exposes live score summaries, reports, and timeline data directly. Missing fields are surfaced as contract errors.",
          tabs: {
            scoreSummary: "Score Summary",
            reports: "Reports",
            timeline: "Timeline",
          },
          cards: {
            byCamp: "By Camp",
            byMember: "By Member",
          },
          stats: {
            totalScore: "Total Score",
            taskCount: "Task Count",
            dispatchedTaskCount: "Dispatched Tasks",
            completedTaskCount: "Completed Tasks",
            pendingScoreTaskCount: "Pending Score Tasks",
            noticeCount: "Announcement Count",
            timelineEventCount: "Timeline Events",
            reportCount: "Report Count",
          },
          contract: {
            situation: "Situation payload",
            summary: "Review summary",
            scoreSummary: "Score summary",
            reports: "Report list",
            timeline: "Timeline",
            byCamp: "Camp summary",
            byMember: "Member summary",
          },
        },
      },
    },
  },
  ja: {
    redblue: {
      pages: {
        review: {
          subtitle: "レビュー画面は特定の演習活動に紐付けて使用します。",
          activitySubtitle: "演習活動 #{activityCode}",
          selectorNotice:
            "レビュー画面は先に演習活動へ紐付ける必要があります。この一覧から状況とレビュー内容を確認したい活動を選択してください。",
          refreshAction: "更新",
          alertTitle:
            "レビュー画面は得点集計、レポート、タイムラインを現在値で直接表示します。フィールド欠落は契約エラーとして明示します。",
          tabs: {
            scoreSummary: "得点集計",
            reports: "レポート",
            timeline: "タイムライン",
          },
          cards: {
            byCamp: "陣営別",
            byMember: "メンバー別",
          },
          stats: {
            totalScore: "総得点",
            taskCount: "タスク総数",
            dispatchedTaskCount: "配布済みタスク",
            completedTaskCount: "完了タスク",
            pendingScoreTaskCount: "採点待ちタスク",
            noticeCount: "告知数",
            timelineEventCount: "タイムライン件数",
            reportCount: "レポート数",
          },
          contract: {
            situation: "状況ペイロード",
            summary: "レビュー集計",
            scoreSummary: "得点集計",
            reports: "レポート一覧",
            timeline: "タイムライン",
            byCamp: "陣営集計",
            byMember: "メンバー集計",
          },
        },
      },
    },
  },
};
